// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"2994575c","455":"24c1d0a8","977":"dc08da06"}[chunkId] + ".chunk.js";
};